import * as $ from 'jquery';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { DoceditorComponent, DownloadBoxComponent, OpendialogBoxComponent, SaveasBoxComponent } from './doceditor/doceditor.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { A11yModule } from '@angular/cdk/a11y';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AuditTrailsModule } from './audit-trails/audit-trails.module';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { BlockUIModule } from 'ng-block-ui';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { CalenderModule } from './calender/calender.module';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { CdkMenuModule } from '@angular/cdk/menu';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { CdkTableModule } from '@angular/cdk/table';
import { CdkTreeModule } from '@angular/cdk/tree';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { CommonModule } from '@angular/common';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { ConfirmationDialogService } from './confirmation-dialog/confirmation-dialog.service';
import { DashboardComponent } from './dashboard/dashboard.component';
import { BsDatepickerModule  } from 'ngx-bootstrap/datepicker';
import { DialogModule } from '@angular/cdk/dialog';
import { DocumentModule } from './document/document.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { EditCalenderDialogComponent } from './edit-calender-options/edit-calender-dialog.component';
import { EditCalenderDialogService } from './edit-calender-options/edit-calender-dialog.service';
import { EmailModule } from './email/email.module';
import { FirmProfileComponent } from './firm-profile/firm-profile.component';
import { FirmnameLoginComponent } from './login/firmname-login/firmname-login.component';
import { ForgotpwdComponent } from './login/forgotpwd/forgotpwd.component';
import { GridComponent } from './grid/grid.component';
import { InvoiceComponent } from './invoice/invoice.component';
import { LoginComponent } from './login/login.component';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { MatterModule } from './matter/matter.module';
import { MessagesModule } from './messages/messages.module';
import { ModelModule } from './model/model.module';
import { NewpageComponent } from './doceditor/newpage/newpage.component';
// import { FilterPipeModule } from 'ngx-filter-pipe';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NotesComponent } from './notes/notes.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { PaymentComponent } from './payment/payment.component';
import { PortalModule } from '@angular/cdk/portal';
import { PracticePartnerComponent } from './firm-profile/practice-partner/practice-partner.component';
import { PreviewComponent } from './invoice/preview/preview.component';
import { RegisterComponent } from './register/register.component';
import { RelationshipModule } from './relationship/relationship.module';
import { ResetpwdComponent } from './login/resetpwd/resetpwd.component';
import { RouterModule } from '@angular/router';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { SharedModule } from './shared/shared.module';
import { TimeSheetComponent } from './time-sheet/time-sheet.component';
import { ToastrModule } from 'ngx-toastr';
import { ViewDocumentComponent } from './view-document/view-document.component';
import { AuthInterceptor } from './interceptor/auth.interceptor';
import { LucideAngularModule, Search, Video, Send, Plus, Minus, ChevronLeft, ChevronRight, ArrowLeft } from 'lucide-angular';
import { CreateinvoiceComponent} from './invoice/createinvoice/createinvoice.component';
import { RegisterotpComponent } from './login/registerotp/registerotp.component';
import { MergepdfComponent } from './mergepdf/mergepdf.component';
import { ShareDocumentsDialogComponent } from './relationship/view-relationship/relationship-exchange/share-documents-dialog/share-documents-dialog.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { DeleteDialogComponent } from './delete-dialog/delete-dialog.component';
import { SuccessDialogComponent } from './success-dialog/success-dialog.component';
import { SafeUrlPipe } from './shared/safe-url.pipe';
import { MatDialogConfig } from '@angular/material/dialog';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideAnalytics, getAnalytics, ScreenTrackingService } from '@angular/fire/analytics';
import { environment } from '../environments/environment';
import { SubscriptionComponent } from './firm-profile/subscription/subscription.component';
import { ConfirmPlanComponent } from './confirm-plan/confirm-plan.component';
import { FilterPipe } from './shared/pipes/filter.pipe';
import { AvailableToggleComponent } from './available-toggle/available-toggle.component';

@NgModule({ declarations: [
        AppComponent,
        DashboardComponent,
        AvailableToggleComponent,
        LoginComponent,
        ForgotpwdComponent,
        GridComponent,
        NotesComponent,
        NotificationsComponent,
        RegisterComponent,
        ResetpwdComponent,
        NewpageComponent,
        ConfirmationDialogComponent,
        EditCalenderDialogComponent,
        FirmnameLoginComponent,
        FirmProfileComponent,
        PracticePartnerComponent,
        SubscriptionComponent,
        InvoiceComponent,
        CreateinvoiceComponent,
        PreviewComponent,
        ViewDocumentComponent,
        PaymentComponent,
        DoceditorComponent,
        OpendialogBoxComponent,
        DownloadBoxComponent,
        SaveasBoxComponent,
        RegisterotpComponent,
        ShareDocumentsDialogComponent,
        ConfirmDialogComponent,
        DeleteDialogComponent,
        SuccessDialogComponent,
        SafeUrlPipe,
        ConfirmPlanComponent
    ],
    bootstrap: [AppComponent],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
    ], imports: [BrowserModule,
        ModelModule,
        AppRoutingModule,
        RouterModule,
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        NgxSpinnerModule,
        OverlayModule,
        LucideAngularModule.pick({
            Search,
            Video,
            Send,
            Plus,
            Minus,
            ChevronLeft,
            ChevronRight,
            ArrowLeft
        }),
        ToastrModule.forRoot(),
        BrowserAnimationsModule,
        BlockUIModule.forRoot(),
        BsDatepickerModule.forRoot(),
        BsDatepickerModule.forRoot(),
        MatterModule,
        RelationshipModule,
        DocumentModule,
        //FilterPipeModule,
        //FilterPipe,
        A11yModule,
        CdkAccordionModule,
        ClipboardModule,
        CdkMenuModule,
        CdkStepperModule,
        CdkTableModule,
        CdkTreeModule,
        DragDropModule,
        MatAutocompleteModule,
        MatBadgeModule,
        MatBottomSheetModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatCardModule,
        MatCheckboxModule,
        MatChipsModule,
        MatStepperModule,
        MatDialogModule,
        MatDividerModule,
        MatExpansionModule,
        MatGridListModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatNativeDateModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatRippleModule,
        MatSelectModule,
        MatSidenavModule,
        MatSliderModule,
        MatSlideToggleModule,
        MatSnackBarModule,
        MatSortModule,
        MatTableModule,
        MatTabsModule,
        MatToolbarModule,
        MatTooltipModule,
        MatTreeModule,
        OverlayModule,
        PortalModule,
        ScrollingModule,
        DialogModule,
        MatDatepickerModule,
        MatFormFieldModule,
        AutocompleteLibModule,
        NgxDocViewerModule,
        BsDatepickerModule.forRoot(),
        SharedModule,
        CalenderModule,
        MessagesModule,
        EmailModule,
        NgxPaginationModule,
        AuditTrailsModule,
        provideFirebaseApp(() => initializeApp(environment.firebase)),
        // provideAnalytics(() => getAnalytics()),
        provideAnalytics(() => {
            const analytics = getAnalytics();
            // only enable in non-production
            if (!environment.production) {
                (window as any)['ga-disable-' + environment.firebase.measurementId] = false;
                (window as any).gtag('config', environment.firebase.measurementId, {
                    'debug_mode': true // ✅ this enables DebugView
                });
            }
            return analytics;
        })], providers: [HttpClient, ConfirmationDialogService, BsDatepickerConfig, EditCalenderDialogService,
        { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: false } },
        { provide: MatDialogRef, useValue: {} },
        { provide: MAT_DIALOG_DATA, useValue: {} },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        {
            provide: MAT_DIALOG_DEFAULT_OPTIONS,
            useValue: {
                hasBackdrop: true,
                backdropClass: 'cdk-overlay-dark-backdrop',
                panelClass: 'success-dialog-panel',
                autoFocus: false,
                restoreFocus: true,
                closeOnNavigation: true,
                disableClose: false
            } as MatDialogConfig
        }, provideHttpClient(withInterceptorsFromDi())] })
export class AppModule { }